export function sumNullableIntegers(
  value1: number | null | undefined,
  value2: number | null | undefined
): number | null {
  if (value1 === null && value2 === null) {
    return null;
  }
  return (value1 || 0) + (value2 || 0);
}

export function roundToTwoDecimals(num: number | null | undefined): number | null {
  if (num === null || num === undefined) {
    return null;
  }

  return Math.round((num + Number.EPSILON) * 100) / 100;
}
